import React, { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useCliente } from "../context/ClienteContext";

import ClienteSelector from "../componentsTecnico/ClienteSelector";
import NativeAlertBell from "../components/NativeAlertBell";
import ThemeToggle from "../components/ThemeToggle";
import { getRol, isTecnico, isSupervisor, isAdmin } from "../utils/auth";
import api from "../api";

export default function Topbar({ mobileMenuOpen = false, onMobileMenuToggle = () => {} }) {
  const {
    clientes,
    clienteSeleccionadoId,
    loadingClientes,
    seleccionarCliente,
  } = useCliente();

  const rol = getRol();
  const showClienteSelector = isTecnico() || isSupervisor() || isAdmin();
  const showNotifications = false; // Reservada para alertas técnicas nativas.
  const [openUser, setOpenUser] = useState(false);
  const [mfaOpen,setMfaOpen]=useState(false),[mfaPassword,setMfaPassword]=useState(""),[mfaSetup,setMfaSetup]=useState(null),[mfaCode,setMfaCode]=useState(""),[mfaError,setMfaError]=useState(""),[recovery,setRecovery]=useState([]);
  const userRef = useRef(null);
  const usuario = useMemo(() => localStorage.getItem("usuario") || "Usuario", []);
  const clientesMantenimiento = useMemo(
    () => (clientes || []).filter((cliente) => Number(cliente.es_cliente_mantenimiento) === 1),
    [clientes]
  );

  useEffect(() => {
    function onDocMouseDown(event) {
      if (userRef.current && !userRef.current.contains(event.target)) setOpenUser(false);
    }
    function onKeyDown(event) {
      if (event.key === "Escape") {
        setOpenUser(false);
      }
    }
    document.addEventListener("mousedown", onDocMouseDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onDocMouseDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);

  const startMfa=async()=>{setMfaError("");try{const r=await api.post('/mfa/setup',{password:mfaPassword});setMfaSetup(r.data);setMfaPassword("");}catch(e){setMfaError(e.response?.data?.error||'No se pudo preparar el segundo factor');}};
  const confirmMfa=async()=>{setMfaError("");try{const r=await api.post('/mfa/confirm',{code:mfaCode});setRecovery(r.data.recovery_codes||[]);setMfaSetup(null);setMfaCode("");}catch(e){setMfaError(e.response?.data?.error||'Código no válido');}};
  const logout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <header className="topbar">
      <div className="topbar-inner">
        <button aria-expanded={mobileMenuOpen} aria-label={mobileMenuOpen ? "Cerrar menú" : "Abrir menú"} className="topbar-mobile-menu" onClick={onMobileMenuToggle} type="button"><span aria-hidden="true">☰</span></button>

        <div className="topbar-product">
          <div className="topbar-product__mark">M</div>
          <div className="topbar-product__copy">
            <div className="topbar-product__name">Mantenimientos</div>
            <div className="topbar-product__sub">Operaciones IT</div>
          </div>
        </div>

        {showClienteSelector ? (
          <div className="topbar-global-search" title={loadingClientes ? "Cargando clientes…" : "Buscar cliente o código"}>
            <span className="topbar-global-search__context">Contexto</span>
            <ClienteSelector
              clientes={clientesMantenimiento}
              value={clienteSeleccionadoId}
              isLoading={loadingClientes}
              compact
              onSeleccionar={(id) => {
                        setOpenUser(false);
                seleccionarCliente(id);
              }}
            />
          </div>
        ) : <div className="topbar-global-search__spacer" />}

        <div className="topbar-actions">
          {showNotifications ? (
            <NativeAlertBell
              onSelectClient={(clientId) => {
                seleccionarCliente(clientId);
                setOpenUser(false);
              }}
              onOpenUser={() => setOpenUser(false)}
            />
          ) : null}


          <ThemeToggle compact />

          <div className="topbar-user" ref={userRef}>
            <button
              aria-expanded={openUser}
              className="topbar-user__trigger"
              onClick={() => {
                setOpenUser((value) => !value);
                      }}
              type="button"
            >
              <span className="topbar-user__avatar">{String(usuario).slice(0, 1).toUpperCase()}</span>
              <span className="topbar-user__name">{usuario}</span>
              <span aria-hidden="true" className="topbar-user__chevron">⌄</span>
            </button>
            {openUser ? (
              <div className="topbar-user__menu">
                <div className="topbar-user__identity">
                  <strong>{usuario}</strong>
                  <span>{rol || "usuario"}</span>
                </div>
                <button className="topbar-user__logout" onClick={() => {setMfaOpen(true);setOpenUser(false);setMfaError("");}} type="button">Seguridad y doble factor</button><button className="topbar-user__logout" onClick={logout} type="button">Cerrar sesión</button>
              </div>
            ) : null}
          </div>
        </div>
      {mfaOpen?createPortal(<div className="modal-overlay mfa-overlay" onMouseDown={e=>e.target===e.currentTarget&&setMfaOpen(false)}><section className="modal" role="dialog" aria-modal="true"><header className="modal-header"><h3>Doble factor</h3><button className="button secondary small" onClick={()=>setMfaOpen(false)}>Cerrar</button></header><div className="modal-body">{recovery.length?<><p>Guarda estos códigos de recuperación. No volverán a mostrarse.</p><code style={{whiteSpace:'pre-wrap'}}>{recovery.join('\n')}</code></>:mfaSetup?<><p>Escanea el QR con Google Authenticator y escribe el código generado.</p><img alt="QR para Authenticator" src={mfaSetup.qr_data_url} style={{width:220,maxWidth:'100%'}}/><p><code>{mfaSetup.manual_secret}</code></p><input className="input" placeholder="Código de 6 dígitos" value={mfaCode} onChange={e=>setMfaCode(e.target.value)}/><button className="button primary" onClick={confirmMfa}>Confirmar y activar</button></>:<><p>Confirma tu contraseña para configurar Authenticator.</p><input className="input" type="password" value={mfaPassword} onChange={e=>setMfaPassword(e.target.value)} placeholder="Contraseña actual"/><button className="button primary" onClick={startMfa}>Generar QR</button></>}{mfaError?<p className="error">{mfaError}</p>:null}</div></section></div>, document.body):null}
      </div>
    </header>
  );
}
